<template lang="pug">
validation-observer(ref='authObserver' v-slot='{ invalid }')
	v-form(@keyup.native.enter='login')
		v-card-text
			validation-provider(v-slot='{ errors }' vid='username' name='Identifiant' rules='required')
				v-text-field(append-icon='info' v-model='username' :error-messages='errors' label='Identifiant' name='username' required='required' :autocomplete="usernameAutocomplete" outlined clearable)
			validation-provider(v-slot='{ errors }' vid='password' name='Mot de passe' rules='required')
				v-text-field(v-model='password' :error-messages='errors' :append-icon="showPassword ? 'visibility' : 'visibility_off'"
					:type="showPassword ? 'text' : 'password'"
					@click:append='showPassword = !showPassword'
					label='Mot de passe' name='password' required='required' :autocomplete="passwordAutocomplete" outlined clearable hide-details)
		//- v-card-actions.d-flex.justify-space-between
			//- v-checkbox.text-hidden(v-model='rememberMe' label='Se souvenir de moi')
			//- a.grey--text(@click='reset') Mot de passe oublié
		v-card-actions.text-center
			v-btn.button_color--text.rounded-pill.mx-auto.px-6.py-5(:loading='loading' color='primary' @click='login' :disabled='invalid') S'identifier
		v-card-actions.text-center.pb-5
			a.grey--text.mx-auto.px-6.py-5(@click='reset') Mot de passe oublié
		SnackBar(v-bind:message='message' v-bind:show='showError')
</template>
<script>
import { required } from "vee-validate/dist/rules";
import {
  extend,
  localize,
  setInteractionMode,
  ValidationObserver,
  ValidationProvider,
} from "vee-validate";
import fr from "vee-validate/dist/locale/fr.json";
import SnackBar from "@/components/common/SnackBar";

localize("fr", fr);
setInteractionMode("eager");

extend("required", required);

export default {
  name: "LoginForm",
  components: {
    SnackBar,
    ValidationProvider,
    ValidationObserver,
  },
  data: () => ({
    username: "",
    password: "",
    passwordAutocomplete: "new-password",
    usernameAutocomplete: "username",
    showPassword: false,
    rememberMe: false,
    loading: false,
    showError: false,
    message: {
      type: "error",
      message: "Les identifiants sont invalides",
    },
  }),
  computed: {
    loggedIn() {
      return this.$store.state.auth.isAuthenticated;
    },
  },
  created() {
    if (this.loggedIn) {
      this.$router.push("/");
    } else {
      const rememberMe = localStorage.getItem("rememberMe");
      this.rememberMe = rememberMe === "1";
    }
  },
  watch: {
    seSouvenirDeMoi: function (newVal) {
      // watch it
      if (newVal) {
        this.passwordAutocomplete = "";
        this.usernameAutocomplete = "";
        localStorage.setItem("rememberMe", "1");
      } else {
        this.passwordAutocomplete = "new-password";
        this.usernameAutocomplete = "username";
        localStorage.removeItem("rememberMe");
      }
    },
  },
  methods: {
    async login() {
      try {
        this.showError = false;
        this.loading = true;
        await this.$recaptchaLoaded();
        const token = await this.$recaptcha('login')
        await this.$store.dispatch("auth/login", {
          username: this.username,
          password: this.password,
          token: token,
        });
        await this.$router.push("/");
        const recaptcha = this.$recaptchaInstance
        recaptcha.hideBadge()
      } catch (error) {
        console.error(error);
        this.showError = true;
      } finally {
        this.loading = false;
      }
    },
    async reset() {
      await this.$router.push("/reset/password");
    },
  },
};
</script>
